import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions, mapMutations } from 'vuex';
import pickBy from 'lodash/pickBy';
import isNil from 'lodash/isNil';
import defer from 'lodash/defer';
import shallowEqualObjects from 'shallow-equal/objects';
import registerStoreModule from '~/helpers/store-helper';
import pageActions from '~/store/modules/pageActions';
import search from '~/store/modules/search';
import { extractCategoryFilterByFromQuery, extractCategorySortByFromQuery, extractCategoryOrderByFromQuery, extractCategoryPreviousPageFromQuery, extractCategoryNextPageFromQuery, extractCategoryQueryFromFilterBy, extractSelectedFilters } from '~/helpers/extract-helper';
import MdmBreadcrumb from '~/components/atoms/Global/MdmBreadcrumb.vue';
import SearchSeo from '~/components/functional/Seo/SearchSeo.vue';
import CategoryTcVars from '~/components/functional/TcVars/CategoryTcVars.vue';
import CategoryLoading from '~/components/templates/Category/CategoryLoading.vue';
import CategoryTemplate from '~/components/templates/Category/CategoryTemplate.vue';
import Empty from '~/components/specific/Blocks/Empty.vue';
export default {
  components: {
    MdmBreadcrumb: MdmBreadcrumb,
    SearchSeo: SearchSeo,
    CategoryTcVars: CategoryTcVars,
    CategoryLoading: CategoryLoading,
    CategoryTemplate: CategoryTemplate,
    Empty: Empty
  },
  httpHeaders: function httpHeaders() {
    return {
      'Cache-Control': 'max-age=0, s-maxage=86400, public'
    };
  },
  data: function data() {
    return {
      loadingProducts: true,
      loadingNextPage: false,
      loadingPreviousPage: false,
      unwatchSearchQuery: null,
      unwatchNextPage: null,
      unwatchPreviousPage: null
    };
  },
  computed: _objectSpread({}, mapGetters({
    baseURL: 'request/baseURL',
    locale: 'i18n/locale',
    description: 'search/description',
    products: 'search/products',
    productsCount: 'search/productsCount',
    filterBy: 'pageActions/filterBy',
    orderBy: 'pageActions/orderBy',
    sortBy: 'pageActions/sortBy',
    previousPage: 'pageActions/previousPage',
    nextPage: 'pageActions/nextPage'
  }), {
    categoryQuery: function categoryQuery() {
      return _objectSpread({}, extractCategoryQueryFromFilterBy(this.filterBy), {
        sort: this.sortBy,
        order: this.orderBy
      });
    },
    selectedFilters: function selectedFilters() {
      return extractSelectedFilters(this.filterBy, this.description.filters);
    },
    currentPath: function currentPath() {
      return "".concat(this.baseURL).concat(this.buildSearchUrl(this.locale, this.description.query));
    },
    breadcrumb: function breadcrumb() {
      var _this = this;

      var breadcrumb = this.description.breadcrumb || [];
      return breadcrumb.map(function (entry) {
        return {
          label: entry.title,
          url: "/".concat(_this.locale.market, "/").concat(_this.locale.language)
        };
      });
    },
    pageTitle: function pageTitle() {
      var _ref, _ref2;

      var replacement = {
        x: this.productsCount,
        y: (_ref2 = this.description) != null ? _ref2.query : _ref2,
        z: (_ref = this.description) != null ? _ref.suggest_query : _ref
      };
      var tradName = 'searchTitle';

      if (!this.productsCount) {
        tradName = 'searchTitleNoResults';
      } else if (this.description.is_corrected) {
        tradName = 'searchTitleCorrect';
      } else if (this.description.suggest_query) {
        tradName = 'searchTitleSuggest';
      }

      return this.$i18n.tc(tradName, this.productsCount, replacement);
    },
    speedcurveConfig: function speedcurveConfig() {
      var luxConfig = {
        innerHTML: 'LUX = window.LUX || {}; LUX.label = "search";'
      };
      return luxConfig;
    }
  }),
  created: function created() {
    var _this2 = this;

    registerStoreModule(this.$store, 'search/', search);
    registerStoreModule(this.$store, 'pageActions/', pageActions);

    if (process.client) {
      var _this$$route = this.$route,
          keyword = _this$$route.params.keyword,
          query = _this$$route.query;
      var args = {
        keyword: keyword,
        query: query
      };
      this.resetPagination();
      this.resetFilters();
      this.resetSearch();
      this.setDefaultFilterBy(extractCategoryFilterByFromQuery(query));
      this.setDefaultSortBy(extractCategorySortByFromQuery(query));
      this.setDefaultOrderBy(extractCategoryOrderByFromQuery(query));
      this.setPreviousPage(extractCategoryPreviousPageFromQuery(query));
      this.setNextPage(extractCategoryNextPageFromQuery(query));

      try {
        this.fetchSearch(args).then(function () {
          _this2.loadingProducts = false;

          _this2.scrollBackToProduct(localStorage.getItem('currentProduct'));

          localStorage.removeItem('currentProduct');
        });
      } catch (error) {
        if (this.$sentry) {
          this.$sentry.captureException(error);
        }
      }
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4() {
      var _this3 = this;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              this.unwatchSearchQuery = this.$watch('categoryQuery',
              /*#__PURE__*/
              function () {
                var _ref3 = _asyncToGenerator(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee(oldVal, newVal) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (shallowEqualObjects(oldVal, newVal)) {
                            _context.next = 7;
                            break;
                          }

                          _this3.loadingProducts = true;
                          _context.next = 4;
                          return _this3.handleWatcher(_this3.fetchSearch, 1);

                        case 4:
                          _this3.resetPagination();

                          _this3.scrollBackToCategoryTitle();

                          _this3.loadingProducts = false;

                        case 7:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x, _x2) {
                  return _ref3.apply(this, arguments);
                };
              }());
              this.unwatchNextPage = this.$watch('nextPage',
              /*#__PURE__*/
              _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee2() {
                var predicate;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        predicate = _this3.nextPage === 1 && _this3.previousPage === 1;

                        if (predicate) {
                          _context2.next = 6;
                          break;
                        }

                        _this3.loadingNextPage = true;
                        _context2.next = 5;
                        return _this3.handleWatcher(_this3.appendProducts, _this3.nextPage);

                      case 5:
                        _this3.loadingNextPage = false;

                      case 6:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              })));
              this.unwatchPreviousPage = this.$watch('previousPage',
              /*#__PURE__*/
              _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee3() {
                var predicate;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        predicate = _this3.nextPage === 1 && _this3.previousPage === 1;

                        if (predicate) {
                          _context3.next = 6;
                          break;
                        }

                        _this3.loadingPreviousPage = true;
                        _context3.next = 5;
                        return _this3.handleWatcher(_this3.prependProducts, _this3.previousPage);

                      case 5:
                        _this3.loadingPreviousPage = false;

                      case 6:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              })));

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    this.unwatchSearchQuery();
    this.unwatchNextPage();
    this.unwatchPreviousPage();
  },
  methods: _objectSpread({}, mapMutations({
    setDefaultFilterBy: 'pageActions/SET_DEFAULT_FILTERBY',
    setDefaultSortBy: 'pageActions/SET_DEFAULT_SORTBY',
    setDefaultOrderBy: 'pageActions/SET_DEFAULT_ORDERBY',
    setPreviousPage: 'pageActions/SET_PREVIOUS_PAGE',
    setNextPage: 'pageActions/SET_NEXT_PAGE',
    resetPagination: 'pageActions/RESET_PAGINATION',
    resetFilters: 'pageActions/RESET_FILTERS',
    resetSearch: 'search/RESET_SEARCH'
  }), mapActions({
    fetchSearch: 'search/fetchContent',
    appendProducts: 'search/appendProducts',
    prependProducts: 'search/prependProducts'
  }), {
    handleWatcher: function () {
      var _handleWatcher = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5(handler, page) {
        var keyword, query;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                keyword = this.$route.params.keyword;
                query = _objectSpread({}, this.categoryQuery, {
                  page: page
                });
                _context5.prev = 2;
                _context5.next = 5;
                return handler({
                  query: query,
                  keyword: keyword
                });

              case 5:
                this.$router.push({
                  query: pickBy(query, function (e) {
                    return !isNil(e);
                  })
                });
                this.$root.$emit('reset-tcvars');
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](2);
                if (this.$sentry) this.$sentry.captureException(_context5.t0);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 9]]);
      }));

      function handleWatcher(_x3, _x4) {
        return _handleWatcher.apply(this, arguments);
      }

      return handleWatcher;
    }(),
    scrollBackToCategoryTitle: function scrollBackToCategoryTitle() {
      var title = document.getElementById('category');

      if (title) {
        window.scrollTo({
          top: title.offsetTop
        });
      }
    },
    scrollBackToProduct: function scrollBackToProduct(arg) {
      if (arg) {
        var currentProduct = JSON.parse(arg);
        defer(function () {
          var product = document.getElementById(currentProduct);

          if (product) {
            window.scrollTo({
              top: product.offsetTop
            });
          }
        });
      }
    }
  }),
  head: function head() {
    return {
      script: [this.speedcurveConfig]
    };
  }
};